import { CampiIntestazione } from './campi-intestazione';

export class Intestazione {
  campi: CampiIntestazione;

  constructor() {
    this.campi = new CampiIntestazione();
  };
}

